import React from 'react';

import { HEADING_DEFAULT_VARIANT, HeadingVariants } from '@life-moments/lifehub-components';

import { getStructureItemLayers, StructureItemLayer } from '~/pages/blocks/edit/components/structure-sidebar/helpers';

import { Block } from '~/types/gists/Block';

import Variant from '../../components/variant';

import styles from './styles.module.scss';

type Props = {
  variants: HeadingVariants[];
  blockName: Block['name'];
};

const content: StructureItemLayer[] = [{ name: 'Heading inner' }];

const HeadingBlockVariants = ({ variants, blockName }: Props): React.JSX.Element => (
  <div className={styles.container}>
    {variants.map(variant => (
      <Variant
        key={variant.name}
        name={variant.displayName}
        isDefault={variant.name === HEADING_DEFAULT_VARIANT.name}
        content={getStructureItemLayers(blockName, content)}
      />
    ))}
  </div>
);

export default HeadingBlockVariants;
